<template>
    <div class="fixed inset-0 overflow-hidden z-60">
        <div class="absolute inset-0 overflow-hidden">
            <transition enter-active-class="ease-in-out duration-500"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in-out duration-500"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0"
            >
                <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                     v-if="show"
                ></div>
            </transition>

            <section class="absolute inset-y-0 sm:pl-16 max-w-full right-0 flex">
                <transition enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                            enter-class="translate-x-full"
                            enter-to-class="translate-x-0"
                            leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
                            leave-class="translate-x-0"
                            leave-to-class="translate-x-full"
                >
                    <div class="w-screen max-w-md"
                         v-if="show"
                    >
                        <div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
                            <div class="flex-1 h-0 overflow-y-auto flex flex-col">
                                <header class="space-y-1 py-6 px-4 bg-primary-600 sm:px-6">
                                    <div class="flex items-center justify-between space-x-3">
                                        <h2 class="text-lg leading-7 font-medium text-white">
                                            {{ heading }}
                                        </h2>
                                        <div class="h-7 flex items-center">
                                            <button aria-label="Close panel" class="text-primary-200 hover:text-white transition ease-in-out duration-150"
                                                    @click="hide"
                                            >
                                                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="text-sm leading-5 text-primary-200">
                                            {{ description }}
                                        </p>
                                    </div>
                                </header>
                                <div class="flex-1 flex flex-col justify-between">
                                    <slot></slot>
                                </div>
                            </div>

                            <slot name="footer" :hide="hide"></slot>
                        </div>
                    </div>
                </transition>
            </section>
        </div>
    </div>
</template>

<script>
	export default {
        data() {
            return {
                show: false,
            }
        },

        props: {
            heading: {
                type: String,
            },

            description: {
                type: String,
                default: ''
            },
        },

        created() {
            setTimeout(() => {
                this.show = true;
            }, 50);
        },

        methods: {
            hide() {
                this.show = false;

                setTimeout(() => {
                    this.$emit('hide');
                }, 500);
            },

            toggle() {
                this.show = ! this.show;
            }
        }
    }
</script>
